// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { API_VERSION, debug } from '@sitecore-cloudsdk/core';
import { LIBRARY_VERSION, EVENTS_NAMESPACE } from '../../consts';
/**
 * This factory function sends an event to Edge Proxy
 * @param body - The event data to send
 * @param settings - The global settings
 */
export async function sendEvent(body, settings) {
    const eventUrl = `${settings.sitecoreEdgeUrl}/v1/events/${API_VERSION}/events?sitecoreContextId=${settings.sitecoreEdgeContextId}&siteId=${settings.siteName}`;
    const fetchOptions = {
        body: JSON.stringify(body),
        headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'X-Library-Version': LIBRARY_VERSION,
        },
        method: 'POST',
    };
    debug(EVENTS_NAMESPACE)('Events request: %s with options: %O', eventUrl, fetchOptions);
    return await fetch(eventUrl, fetchOptions)
        .then((response) => {
        debug(EVENTS_NAMESPACE)('Events response: %O', response);
        return response.json();
    })
        .then((data) => {
        debug(EVENTS_NAMESPACE)('Events payload: %O', data);
        return data;
    })
        .catch((error) => {
        debug(EVENTS_NAMESPACE)('Error: events response: %O', error);
        return null;
    });
}
